"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxField = void 0;
var _mui = require("@ori-ui/mui");
var _react = _interopRequireDefault(require("react"));
var _reactHookForm = require("react-hook-form");
var _jsxRuntime = require("react/jsx-runtime");
const CheckboxField = props => {
  const {
    name,
    label,
    color = 'primary',
    disabled,
    required,
    icon,
    checkedIcon
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactHookForm.Controller, {
    name: name,
    render: ({
      field
    }) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.FormControl, {
      sx: {
        marginBottom: 0
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.FormControlLabel, {
        control: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Checkbox, {
          ...field,
          id: name,
          checked: field.value,
          value: field.value,
          inputRef: field.ref,
          color,
          disabled,
          required,
          icon,
          checkedIcon
        }),
        id: name,
        label: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
            variant: "body1"
            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- TODO we must fixed and checked correct working in separate story
            ,
            fontWeight: field.value ? 'bold' : 'normal',
            children: label
          })
        }),
        sx: {
          marginRight: 0
        }
      })
    })
  });
};
exports.CheckboxField = CheckboxField;
//# sourceMappingURL=CheckboxField.js.map